/* global window, document, URL, Blob */

import * as R from 'ramda';

export default function ECATCompletedAssessmentController(
  $filter,
  $q,
  $rootScope,
  $scope,
  confirmDialog,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  editAssessmentDocumentDialog,
  performAssessmentDialog,
  ssDialogService,
  userService,
  alerts,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.documentsLoaded = false;

  vm.handleAttachDocument = _handleAttachDocument;
  vm.handleDownloadAllDocuments = _handleDownloadAllDocuments;

  vm.handleExpand = _handleExpand;
  vm.handleUncomplete = _handleUncomplete;
  vm.handleDelete = _handleDelete;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initPermissions();
    _initEventListeners();

    if (vm.assessment.templateId === 1) {
      vm.frameworkName = 'CAT / ACET';
    } else {
      vm.frameworkName = 'CRI';
    }
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('ecat').then(permissions => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshECATAssessmentDocuments', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        _refreshAssessmentDocuments();
      }
    });
  }

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshAssessmentDocuments();
    }
  }

  function _refreshAssessmentDocuments() {
    vm.documentsLoaded = false;
    loaderService.showViewLoader = true;
    vm.assessment.assessmentDocuments = null;
    ecatDataService
      .getAssessmentDocumentsByAssessment(vm.assessment.assessmentId)
      .then(response => {
        vm.assessment.assessmentDocuments = response.data.result;
      })
      .finally(() => {
        loaderService.showViewLoader = false;
        vm.documentsLoaded = true;
      });
  }

  function _handleAttachDocument($event) {
    ecatDataService.getAssessmentDocumentTypes().then(response => {
      const documentTypes = response.data.result;
      ssDialogService.dialogs.ecat.editDocumentAttachmentDialog = ssDialogService.alert(
        editAssessmentDocumentDialog.getOptions($event, {
          assessment: vm.assessment,
          document: {
            assessmentDocumentId: 0,
            deletable: true,
          },
          documentTypes,
        }),
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editDocumentAttachmentDialog);
    });
  }

  function _handleDownloadAllDocuments() {
    loaderService.showViewLoader = true;
    ecatDataService.downloadAllAssessmentDocuments(vm.assessment.assessmentId).then(response => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob([response.data], { type: 'application/x-zip-compressed' });

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }

  // Uncomplete Assessment

  function _handleUncomplete($event) {
    ssDialogService.dialogs.ecat.uncompleteCompletedAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unapprove Assessment?',
        message: `Are you sure you want to Uncomplete Assessment "${vm.assessment.name}"? This will make the Assessment
         active again."`,
        handleYesClick: _handleConfirmUncomplete,
        handleNoClick: _handleCancelUncomplete,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.ecat.uncompleteCompletedAssessmentConfirmDialog);
  }

  function _handleConfirmUncomplete() {
    loaderService.showViewLoader = true;
    return ecatDataService
      .uncompleteAssessment(vm.assessment.assessmentId)
      .then(() => {
        alerts.success('The Assessment has been uncompleted successfully.');
        $rootScope.$broadcast('refreshECATAssessments');
        _closeUncompleteialog();
      })
      .catch(() => {
        alerts.error('An error occurred uncompleting the Assessment.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelUncomplete() {
    _closeUncompleteialog();
  }

  function _closeUncompleteialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.uncompleteCompletedAssessmentConfirmDialog);
  }

  // Delete Assessment

  function _handleDelete($event) {
    ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Assessment?',
        message: `Are you sure you want to delete assessment "${vm.assessment.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    const assessmentId = vm.assessment.assessmentId;
    return ecatDataService
      .deleteAssessment(assessmentId)
      .then(() => {
        const assessment = $filter('filter')(ecatSharedModelService.assessments, { assessmentId })[0];
        ecatSharedModelService.assessments.splice(ecatSharedModelService.assessments.indexOf(assessment), 1);
        alerts.success('The assessment has been deleted successfully.');
        $rootScope.$broadcast('refreshECATAssessments');
        _closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the assessment.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.deleteAssessmentConfirmDialog);
  }
}

ECATCompletedAssessmentController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',
  'confirmDialog',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'editAssessmentDocumentDialog',
  'performAssessmentDialog',
  'ssDialogService',
  'userService',
  'alerts',
];
